import React from 'react'
import SbEditable from 'storyblok-react'

const OneColWrapper = ({ block, children, className }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`content-block-one-col ${
          block?.block_align_left ? 'content-block-one-col-align-left' : ''
        } ${className} ${block.space_top} ${block.space_bottom}`}
      >
        <div className="content-block-one-col-wrapper">
          <div className="content-block-one-col-body">
            <div className="row">
              <div className="content-col-1">{children}</div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default OneColWrapper
